import { render, staticRenderFns } from "./Bind.vue?vue&type=template&id=f80bb50c";
import script from "./Bind.vue?vue&type=script&lang=js";
export * from "./Bind.vue?vue&type=script&lang=js";

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;